import React from "react";

function BadgeIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.0281 7.51917L9.91185 12.4927C9.92175 12.5512 9.91354 12.6114 9.8883 12.6652C9.86307 12.719 9.82202 12.7637 9.77065 12.7935C9.71928 12.8234 9.66003 12.8368 9.60082 12.832C9.54162 12.8272 9.48529 12.8045 9.43935 12.7668L7.35102 11.1994C7.25021 11.1241 7.12774 11.0834 7.0019 11.0834C6.87605 11.0834 6.75359 11.1241 6.65277 11.1994L4.56094 12.7662C4.51504 12.8038 4.45877 12.8265 4.39964 12.8313C4.34051 12.8361 4.28133 12.8227 4.22999 12.793C4.17865 12.7633 4.1376 12.7186 4.11231 12.6649C4.08702 12.6113 4.07869 12.5512 4.08844 12.4927L4.9716 7.51917"
                stroke="currentColor"
                strokeWidth="1.16667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7 8.16663C8.933 8.16663 10.5 6.59962 10.5 4.66663C10.5 2.73363 8.933 1.16663 7 1.16663C5.067 1.16663 3.5 2.73363 3.5 4.66663C3.5 6.59962 5.067 8.16663 7 8.16663Z"
                stroke="currentColor"
                strokeWidth="1.16667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default BadgeIcon;
